module.exports = __webpack_public_path__ + "static/media/MeterVibe_logo_1444x596.0364e28b.png";